export const simpleHash = (value: Uint8Array): string => {
  let res = 0;

  for (let i = 0; i < value.length; i++) {
    res += value[i];
  }

  return `${res % 1000000000000}`;
};
